import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import platformPipelinePlugin from '@internal/backstage-plugin-platform-pipeline';
import rdsAdminPlugin from '@internal/backstage-plugin-rds-admin';
import analyticsPlugin from '@internal/backstage-plugin-analytics';
import deliveryPlugin from '@internal/backstage-plugin-delivery';
import devHomePlugin from '@internal/backstage-plugin-dev-home';
import productivityPlugin from '@internal/backstage-plugin-productivity';
import scorecardsPlugin from '@internal/backstage-plugin-scorecards';
import { navModule } from './modules/nav';
import { themeModule } from './modules/theme';
import { catalogModule } from './modules/catalog';
import { signInModule } from './modules/auth';
import { graphiqlModule } from './modules/graphiql';
import { scaffolderModule } from './modules/scaffolder';
import { onboardingModule } from './modules/onboarding';
import { notificationSettingsModule } from './modules/webNotifications';

export default createApp({
  features: [
    catalogPlugin,
    platformPipelinePlugin,
    rdsAdminPlugin,
    analyticsPlugin,
    deliveryPlugin,
    devHomePlugin,
    productivityPlugin,
    scorecardsPlugin,
    navModule,
    themeModule,
    catalogModule,
    signInModule,
    graphiqlModule,
    scaffolderModule,
    onboardingModule,
    notificationSettingsModule,
  ],
});
